// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const projectInfo = {
    "name": "labportal2",
    "version": "2.24.0"
};
/* tslint:enable */



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-sandbox-build/src/environments/version.ts